import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "antd";
import { getUserTags, getActiveMasterTag } from "../../Services/tags"
import TagSelect from "../../Component/MasterTag/";


const UserTagModal = ({ visible, onClose, user, onUpdate, submit_loading }) => {
    const [form] = Form.useForm();

    const [selectedTags, setSelectedTags] = useState([]);
    const [userTagOptions, setUserTagOptions] = useState([]);


    const fetchUserTags = async (id) => {
        if (!id) return;
        try {
            const user_tags = await getUserTags(id);
            const userTagIds = user_tags.data.map((t) => t.id);
            const selectedOption = user_tags.data.map((item) => ({
                label: item.name,
                value: item.id,
            }))
            setUserTagOptions((prev) => {
                const merged = [...prev, ...selectedOption];
                const unique = Array.from(new Map(merged.map(t => [t.value, t])).values());
                return unique;
            });
            setSelectedTags(userTagIds);
            form.setFieldsValue({ tag_ids: userTagIds });
        } catch (err) {
            console.log("fetch user Failed:", err);
        }
    };

    useEffect(() => {
        if (user && visible === true) {
            fetchUserTags(user?.id);
        }
    }, [user, form, visible]);

    const handleSubmit = async () => {
        try {
            // const values = await form.validateFields();
            console.log(selectedTags)
            await onUpdate(user?.id, selectedTags);
        } catch (error) {
            console.log("Validate Failed:", error);
        }
    };

    const handleCancel = () => {
        form.resetFields(); // Clears the form fields
        onClose(); // Close the modal
    };


    return (
        <Modal
            title={`#${user?.id} Update User Tag`}
            open={visible}
            onCancel={handleCancel}
            footer={null}
            maskClosable={false}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item
                    name="tag_ids"
                    label="User Tags"
                    rules={[{ required: false, message: "Please select tags" }]}
                >
                    <TagSelect
                        value={selectedTags}
                        onChange={setSelectedTags}
                        fetchTags={getActiveMasterTag}
                        userTagOptions={userTagOptions}
                    />
                </Form.Item>

                <Form.Item className="flex justify-end">
                    <Button type="primary" htmlType="submit" loading={submit_loading}>
                        Save
                    </Button>
                </Form.Item>
            </Form>

        </Modal>
    );
}

export default UserTagModal;
